<template lang="pug">
div
  v-dialog(v-model="showAviso", width="50%", max-height="70%")
    v-card.br-10
      v-card-title.font-weight-semibold.Poppins(style="font-size: 20px") Aviso
      v-card
        v-card-text
          v-layout(row, wrap)
            v-flex.md12
              span.subheading.Poppins(color="") Por questões de segurança o comprovante do repasse fica disponível por 60 dias após a efetivação do mesmo. Caso necessite do comprovante favor entrar em contato com nosso financeiro.
        v-card-actions
          v-spacer
          v-btn.Poppins(@click="showAviso = false;", flat) Fechar
  v-dialog(v-model="showComprovante", width="50%", max-height="70%")
    v-card.br-10(v-if="repasse")
      v-card-title.Poppins
        v-flex.md8
          .title Repasse Realizado
          .body-1.Poppins.gray--text.mt-1 {{ $dayjs(repasse.data_inicio).format("DD/MM/YYYY")}} até {{ $dayjs(repasse.data_fim).format("DD/MM/YYYY") }}.
        v-flex.md4.text-xs-right
          .body-1(style="cursor: pointer;", @click="$emit('showFatura', repasse.fatura);") veja detalhes
      v-card
        v-card-text
          v-layout(row, wrap)
            v-flex.md12
              .subheading.Poppins A transferência foi realizada em {{ $dayjs(repasse.data_pagamento).format("DD/MM/YYYY")}}.
              .subheading.Poppins Clique abaixo e veja o comprovante.
        v-card-actions
          v-spacer
          v-btn.Poppins(@click="showComprovante = false;", flat) Cancelar
          v-btn.Poppins(@click="openComprovante(repasse)", flat, color="white").verdeFinanceiro Comprovante
</template>

<script>
import _ from "lodash";

export default {
  props: {
    showFatura: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data () {
    return {
      showAviso: false,
      showComprovante: false,
      repasse: null,
      fatura: null,
    }
  },
  methods: {
    comprovanteDisponivel (data_repasse) {
      if (!data_repasse) {
        return false;
      }

      const dataRepasse = this.$dayjs(data_repasse);
      const dataAtual = this.$dayjs();
      const diferencaDias = dataAtual.diff(dataRepasse, 'day');

      return diferencaDias <= 60;
    },
    openComprovante (repasse) {
      const vm = this;
      if (vm.comprovanteDisponivel(repasse.data_repasse)) {
        window.open(repasse.comprovante, '_blank');
      } else {
        vm.showAviso = true;
      }
    },
    open (repasse, fatura) {
      if (this.$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO) {
        this.showComprovante = true;
      } else {
        this.showAviso = true;
      }
      this.repasse = repasse;
      this.fatura = fatura;
    },
    close () {
      this.showAviso = false;
      this.showComprovante = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.content-text{
  white-space: normal;
  word-wrap: break-word;
  height: auto;
}
</style>
